
	import { Component, Vue } from 'vue-property-decorator';
	import { SavedRxNames } from '@/store/engine/modules/SavedRxModule';
	import SavedRxListItem from '@/views/saved-rx-list/components/SavedRxListItem.vue';
	import { Observer } from 'mobx-vue';
	import DualButtonModal from '@/components/modals/DualButtonModal.vue';
	import GearsSVG from '@/components/GearsSVG.vue';
	import { joinPath } from '@/utils';

	@Observer
	@Component({
		components: { DualButtonModal, SavedRxListItem, GearsSVG }
	})
	export default class OrderStyles extends Vue {
		rxList: SavedRxNames = [];
		private savedRx: SavedRxNames[number] | null = null;
		private rxModal = false;

		private async back() {
			await this.$router.push('results');
		}

		async manage() {
			for (let i = 0; i < 600; i++) {
				if (!this.$state._patient.isDirty) {
					close();
					location.replace(joinPath(this.$state.redirectUri, '/saved-rx-list'));
					return;
				}

				this.$state.utils.displayMetadataWaitingPopup = true;
				await new Promise((r) => setTimeout(r, 100));
			}

			this.$state.utils.displayMetadataWaitingPopup = false;
			location.replace(this.$state.redirectUri);
		}

		selectRX(rx: SavedRxNames[number]) {
			this.savedRx = rx;
			this.$state.product.setCurrentStyle(this.savedRx.fileName);
			this.$state.product.currentSavedRXTitle = this.savedRx.fileName;
			this.rxChanged();
			this.$router.push('prescription#');
		}

		private async activated() {
			this.rxList = await this.$state.engine.savedRx.getRxList();
		}

		private isActive(option) {
			return option ? 'selectionButton selected' : 'selectionButton';
		}

		private async rxChanged() {
			if (!this.savedRx) return;
			const rx = await this.$engine.savedRx.getRx(this.savedRx.fileName, this.savedRx.companyID);
			try {
				if (rx) {
					const fileData = JSON.parse(rx.fileData);
					this.$state.prescription.newPrescription = fileData;
					if (fileData.notes) {
						this.$state._patient.patientUIData.notes +=
							this.$state._patient.patientUIData.notes.length > 0 ? `\n${fileData.notes}` : fileData.notes;
					}
					this.$state.prescription.validatePrescriptionByScans(this.$state.biometric.leftScanExists, this.$state.biometric.rightScanExists);
					await this.$state.prescription.savePrescription(false);
					await this.$state.prescription.onPrescriptionChanged(false);
				}
			} catch (e) {
				this.$state.utils.pushMessage(`Saved prescription '${this.savedRx.fileName}' is corrupted`, true);
				console.error(`Saved rx ${this.savedRx.fileName} is corrupted`, e);
			}
		}
	}
